import styled from 'styled-components';

export const Nav = styled.nav`
  position: fixed;
  z-index: 99;
  width: 100%;
  background-color: #222;
  border-color: #080808;
  background-image: linear-gradient(to bottom, #3c3c3c 0, #222 100%);
  color: white;

  ul {
    position: relative;
    width: 100%;
    max-height: 0px;
    transition: max-height 0.3s ease;
    flex-direction: column;
    overflow: hidden;

    li {
      width: 100%;
      text-align: center;
      a {
        display: block;
        color: #777;
        padding: 25px 15px;

        font-size: 1.13rem;
        font-weight: 700;
      }

      &:hover {
        a {
          color: #ffffff;
        }
      }

      &.active {
        a {
          background-image: linear-gradient(to bottom, #222 0, #282828 100%);
          box-shadow: inset 0 3px 9px rgba(0, 0, 0, 0.25);
          color: #ffffff;
        }
      }
    }

    &.expanded {
      display: flex;
      max-height: 300px;
    }

    @media (min-width: 768px) {
      display: flex;
      flex-direction: row;
      max-height: 300px;
      li {
        width: auto;
        a {
          display: inline-block;
        }
        &:last-child {
          margin-left: auto;
        }
      }
    }
  }
`;

export const Container = styled.div`
  width: 100%;
  max-width: ${props => props.theme.maxWidth};
  margin: 0 auto;
`;

export const Burger = styled.button`
  float: right;
  padding: 9px 10px;
  margin-top: 8px;
  margin-right: 15px;
  margin-bottom: 8px;
  background-color: transparent;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
  color: #ffffff;

  .icon-bar {
    display: block;
    width: 22px;
    height: 2px;
    border-radius: 1px;
    background-color: #ffffff;
    &:not(:first-child) {
      margin-top: 4px;
    }
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }

  @media (min-width: 768px) {
    display: none;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Header/Styles.js